import React from 'react'
import { Route, BrowserRouter, Switch } from 'react-router-dom'
import {PrivateRoute} from './components/PrivateRoute'
import Home from './pages/home'
import StockTransfers from './pages/stock/index'
import StockTransfersToCheck from './pages/stock/tocheck'
import StockTransfersTosend from './pages/stock/toSend'
import StockTransfersSent from './pages/stock/sent'
import StockTransfersToRejected from './pages/stock/Rejected'
import GridTest from './pages/stock/GridTest'
import LotDetail from './components/stock/detail'
import ScrollToTop from './components/ScrollTop'
import Login from './components/Login'
import SalesScanner from './pages/sales/index'

export default props => (
    <BrowserRouter>
        <ScrollToTop>
            <Switch>
                <Route exact path='/login' component={ Login } />
                <PrivateRoute exact path='/' component={ Home } />
                <PrivateRoute exact path='/stock/transfers' component={StockTransfers} />
                <PrivateRoute exact path='/stock/transfers/todo' component={StockTransfers} />
                <PrivateRoute exact path='/stock/transfers/tocheck'  component={StockTransfersToCheck} />
                <PrivateRoute exact path='/stock/transfers/tosend'  component={StockTransfersTosend} />
                <PrivateRoute exact path='/stock/transfers/sent'  component={StockTransfersSent} />
                <PrivateRoute exact path='/stock/transfers/rejected'  component={StockTransfersToRejected} />
                <PrivateRoute exact path='/stock/transfers/:itemstatus/detail/:id' component={LotDetail}/>
                <PrivateRoute exact path='/stock/test' component={GridTest} />
                <PrivateRoute exact path='/sales/scan' component={SalesScanner} />
            </Switch>
        </ScrollToTop>
    </BrowserRouter>
)